import TransitionType from "../enum/TransitionType";

export default function(input){

    switch(input){

        case TransitionType.FADE: return 'dmb-transition-fade';
        case TransitionType.FADE_UP: return 'dmb-transition-fadeUp';
        case TransitionType.FADE_DOWN: return 'dmb-transition-fadeDown';
        case TransitionType.FADE_LEFT: return 'dmb-transition-fadeLeft';
        case TransitionType.FADE_RIGHT: return 'dmb-transition-fadeRight';

        case TransitionType.SLIDE_UP: return 'dmb-transition-slideUp';
        case TransitionType.SLIDE_DOWN: return 'dmb-transition-slideDown';
        case TransitionType.SLIDE_LEFT: return 'dmb-transition-slideLeft';
        case TransitionType.SLIDE_RIGHT: return 'dmb-transition-slideRight';

        case TransitionType.ZOOM: return 'dmb-transition-zoom';
        case TransitionType.BOUNCE: return 'dmb-transition-bounce';

        default: return '';
    }
}